(function() {
  'use strict';
  
  angular
    .module('app')
    .run(appRun);
    
  appRun.$inject = ['$log', '$rootScope', '$transitions', 'settings', 'version'];
  
  function appRun($log, $rootScope, $transitions, settings, version) {    
    $log.info('MARS ' + version);
    
    $rootScope.goToPreviousState = goToPreviousState;
    settings.load();

    
    $transitions.onSuccess({}, function(transition) {
      var fromState = transition.from();
      var fromParams = transition.params('from');
      var toState = transition.to();
      var toParams = transition.params('to');
      $rootScope.previousState = fromState;
      $rootScope.previousStateParams = fromParams;
      $log.debug(fromState.name + ' -> ' + toState.name, toParams);
      // It's important that this has a higher priority than other services
      // hooks so that they have access to the correct previousState.
    }, { priority: 100 });


    function goToPreviousState(defaultState, defaultParams) {
      if (!$rootScope.previousState || !$rootScope.previousState.name)
        return $state.go(defaultState, defaultParams);
      return $state.go($rootScope.previousState, $rootScope.previousStateParams);
    }

  }
  
})();